/*
 * SteloSupps · Cross-Sell "Passt zu deiner Routine" (Agent-Board AB-25)
 *
 * Aufgabe: Wenn im Baustein stelo-pdp-cross-sell mindestens ein Zusatzprodukt
 * angehakt ist, wird das Hauptprodukt zusammen mit allen angehakten Zusatz-
 * produkten in EINEM Request in den Warenkorb gelegt.
 *
 * Wichtig zur Reihenfolge der Listener:
 * Horizon registriert seine deklarativen on:*-Bindings (assets/component.js,
 * registerEventListeners) als EINEN delegierten Listener pro Event-Typ auf
 * document mit { capture: true }. Ein Capture-Listener am <form> liefe also
 * ZU SPAET - das Theme haette das Produkt schon abgeschickt (doppelter
 * Warenkorb-Eintrag). Darum haengt dieser Listener ebenfalls auf document in
 * der Capture-Phase und muss VOR dem Theme registriert sein. Das ist der
 * Grund, warum diese Datei als klassisches <script> (ohne defer, ohne module)
 * im Body eingebunden wird: klassische Skripte laufen waehrend des Parsens,
 * alle Theme-Module sind type="module" und damit deferred.
 *
 * Ist nichts angehakt, greift dieses Skript nicht ein - dann laeuft exakt der
 * normale Theme-Pfad.
 */
(function () {
  'use strict';

  if (window.__steloCrossSellReady) return;
  window.__steloCrossSellReady = true;

  var BLOCK_SELECTOR = '[data-stelo-cross-sell]';
  var BOX_SELECTOR = 'input[type="checkbox"][data-variant-id]';

  /* Merkt sich die Auswahl je Hauptprodukt, damit ein Variantenwechsel
     (variant:update morpht Teile der Section) die Haken nicht verliert. */
  var selected = Object.create(null);

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function blockFor(productId) {
    return document.querySelector(BLOCK_SELECTOR + '[data-product-id="' + productId + '"]');
  }

  function checkedBoxes(block) {
    return toArray(block.querySelectorAll(BOX_SELECTOR)).filter(function (box) {
      return box.checked && !box.disabled;
    });
  }

  function remember(block) {
    var key = block.getAttribute('data-product-id');
    if (!key) return;
    selected[key] = checkedBoxes(block).map(function (box) {
      return box.getAttribute('data-variant-id');
    });
  }

  function restore(block) {
    var key = block.getAttribute('data-product-id');
    var keep = key ? selected[key] : null;
    if (!keep || !keep.length) return;
    toArray(block.querySelectorAll(BOX_SELECTOR)).forEach(function (box) {
      if (keep.indexOf(box.getAttribute('data-variant-id')) !== -1) box.checked = true;
    });
  }

  function restoreAll() {
    toArray(document.querySelectorAll(BLOCK_SELECTOR)).forEach(restore);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.matches !== 'function' || !target.matches(BOX_SELECTOR)) return;
    var block = target.closest(BLOCK_SELECTOR);
    if (block) remember(block);
  });

  document.addEventListener('variant:update', restoreAll);
  document.addEventListener('DOMContentLoaded', restoreAll);

  function cartSectionIds() {
    var ids = [];
    toArray(document.querySelectorAll('cart-items-component')).forEach(function (el) {
      if (el.dataset && el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) {
        ids.push(el.dataset.sectionId);
      }
    });
    return ids.join(',');
  }

  function cartAddUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) {
      return window.Theme.routes.cart_add_url;
    }
    return '/cart/add';
  }

  /* Gleiche Signatur wie CartAddEvent aus assets/events.js:
     Event-Name 'cart:update', bubbles, detail = { resource, sourceId, data }.
     source: 'product-form-component' ist bewusst gesetzt - cart-icon.js
     behandelt itemCount dann als Zuwachs, nicht als absoluten Warenkorbstand. */
  function dispatchCartUpdate(host, productId, itemCount, sections) {
    host.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: host.id || '',
          data: {
            source: 'product-form-component',
            productId: productId,
            itemCount: itemCount,
            sections: sections,
          },
        },
      })
    );
  }

  function dispatchCartError(host, response) {
    host.dispatchEvent(
      new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          sourceId: host.id || '',
          message: (response && response.message) || '',
          description: (response && response.description) || '',
          errors: (response && response.errors) || null,
        },
      })
    );
  }

  function showBlockError(block, text) {
    var slot = block.querySelector('[data-stelo-cross-sell-error]');
    if (!slot) return;
    slot.textContent = text || '';
    slot.hidden = !text;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM' || typeof form.closest !== 'function') return;

      var host = form.closest('product-form-component');
      if (!host) return;

      var productId = host.getAttribute('data-product-id');
      if (!productId) return;

      var block = blockFor(productId);
      if (!block) return;

      var chosen = checkedBoxes(block);
      if (!chosen.length) return; // nichts ausgewaehlt -> Theme-Pfad unveraendert

      var data = new FormData(form);
      var mainVariantId = Number(data.get('id'));
      if (!mainVariantId) return; // ohne Varianten-ID nicht eingreifen

      var quantity = Number(data.get('quantity'));
      if (!quantity || quantity < 1) quantity = 1;

      /* Ab hier uebernimmt dieses Skript. stopImmediatePropagation verhindert,
         dass der ebenfalls auf document/capture liegende Theme-Listener laeuft. */
      event.preventDefault();
      event.stopImmediatePropagation();

      showBlockError(block, '');

      var items = [{ id: mainVariantId, quantity: quantity }];
      var mainHandle = block.getAttribute('data-product-handle') || '';

      chosen.forEach(function (box) {
        var variantId = Number(box.getAttribute('data-variant-id'));
        if (!variantId) return;
        items.push({
          id: variantId,
          quantity: 1,
          properties: { _addon: mainHandle },
        });
      });

      var totalQuantity = items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);

      var button = form.querySelector('[ref="addToCartButton"]');
      if (button) button.setAttribute('aria-busy', 'true');
      block.setAttribute('aria-busy', 'true');

      fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: cartSectionIds() }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response && response.status) {
            dispatchCartError(host, response);
            showBlockError(block, response.description || response.message || '');
            return;
          }
          dispatchCartUpdate(host, productId, totalQuantity, response && response.sections);
        })
        .catch(function (error) {
          console.error('[stelo-cross-sell]', error);
          showBlockError(block, '');
        })
        .then(function () {
          if (button) button.removeAttribute('aria-busy');
          block.removeAttribute('aria-busy');
        });
    },
    true
  );
})();
